import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
/* src/app/page.dashboard/view.scss: no such file or directory */`],
})
export class PageDashboardComponent implements OnInit {
    public stats: any[] = [];
    public recentItems: any[] = [];
    public loading: boolean = true;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("overview");
        if (code === 200) {
            this.stats = data.stats || [];
            this.recentItems = data.recent || [];
        }

        this.loading = false;
        await this.service.render();
    }
}

export default PageDashboardComponent;